import React, {useContext, useEffect, useState} from 'react'
import ReserveCard from './ReserveCard'

export default function ReserveList ({user}){

const [reservas, setReservas] = useState(null);
const [loading, setLoading] = useState(true);

    
      useEffect(() => {
        const data = {
            peticion: 10,
                idEntidad: user.idEntidadG
                 }
                 //console.log(data)
       const consultarReservas = async () =>{
        try {
        const response = await fetch('https://estanciamargarita.com.ar/backendGama/php/servicios/servicioEntidadG.php', {
            method: 'POST',
            headers: new Headers(), // no incluimos Content-Type para evitar preflight
            body: JSON.stringify(data),
    })
    const result = await response.json();
    setReservas(result)
    setLoading(false);
}
    catch(error){
        console.error(error);
    }
       }
       consultarReservas();
      }, [user]);


    return (
        <div className='flex-1   m-5 rounded-lg'>
       
        { loading ? <p className='text-center text-white text-2xl '>Cargando...</p> : null}
        { reservas ?
            reservas?.map((reserva, index) => {
                return (
                <>
                
                <ReserveCard reserva={reserva} id={index} user={user}/>
              
                </>
                         )})
                        
                        
   : null}
        
       

        </div>
    )
} 